<template>
    <div class="bg-white">
        <Head>
            <title>Продукти</title>
        </Head>
        <Header pageName="Продукти" :cart-count="cartCount"/>
        <flash-message :message="flash.error"/>
        <div class="mx-auto max-w-2xl px-4 py-4 sm:px-6 sm:py-8 lg:max-w-7xl lg:px-8">
            <h2 class="page-title">Продукти</h2>
            <div v-if="products.length === 0" class="my-8 text-gray-500">
                Поки немає доступних продуктів.
            </div>
            <div class="grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-2 lg:grid-cols-3 xl:gap-x-8 mt-6">
                <div v-for="product in products" :key="product.id" class="group">
                    <Link :href="$route('products.view', product.id)">
                        <div class="aspect-h-1 aspect-w-1 w-full overflow-hidden rounded-lg bg-gray-200 xl:aspect-h-8 xl:aspect-w-7">
                            <img v-if="product.images"
                                 :src="`/storage/${product.images}`"
                                 :alt="product.name"
                                 class="h-full w-full object-cover object-center group-hover:opacity-75"/>
                            <div v-else class="h-full w-full flex items-center justify-center bg-gray-100 text-gray-400">
                                Без фото
                            </div>
                        </div>
                        <p class="mt-3 text-xl font-bold text-gray-900">{{ product.name }}</p>
                        <p class="mt-1 text-lg font-medium text-sky-700">{{ product.price }} грн</p>
                        <p v-if="!product.in_stock" class="mt-1 text-sm text-red-500 font-medium">Немає в наявності</p>
                        <p v-else class="mt-1 text-sm text-green-600 font-medium">В наявності: {{ product.quantity }} шт.</p>
                    </Link>
                    <button
                        v-if="product.in_stock"
                        class="btn-indigo btn-booking modal-booking-btn"
                        :disabled="addingId === product.id"
                        @click="addToCart(product)"
                    >
                        {{ addingId === product.id ? 'Додаємо...' : 'Додати до кошика' }}
                    </button>
                </div>
            </div>
            <div v-if="listDescription" class="mt-4 leading-7 prose max-w-none" v-html="listDescription"/>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Header from '@/Component/Header'
import FlashMessage from '@/Component/FlashMessage'

export default {
    components: {Head, Header, Link, FlashMessage},
    props: {
        products:        {type: Array, default: () => []},
        listDescription: {type: String, default: ''},
        cartCount:       {type: Number, default: 0},
    },
    data() {
        return {
            flash: this.$page.props.flash || {},
            addingId: null,
        }
    },
    methods: {
        addToCart(product) {
            this.addingId = product.id
            this.$inertia.post(
                this.$route('cart.products.add', product.id),
                { quantity: 1 },
                { onFinish: () => { this.addingId = null } }
            )
        },
    },
}
</script>
